import { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../hooks/useApi";
import { api, toList } from "../../lib/api";
import { PageHeader, Loader, ErrorNote, Empty } from "../../components/app/kit";
import { ThreadView } from "../../components/app/ThreadView";
import { ThreadList } from "../coach/Messages";

export default function RecruiterMessages() {
  const list = useApi("/recruiter/messages");
  const [sel, setSel] = useState(null);
  const thread = useApi(sel && `/recruiter/messages/thread?player_id=${sel.player_id}`);
  const threads = toList(list.data, ["threads"]);

  const send = async (body) => {
    await api.post(`/recruiter/players/${sel.player_id}/message`, { body });
    thread.reload();
    list.reload();
  };

  return (
    <div>
      <PageHeader eyebrow="Recruiter ↔ coach" title="Messages" />
      {list.loading ? <Loader /> : list.error ? <ErrorNote error={list.error} /> : !threads.length ? <Empty title="No conversations" text="Open a prospect on your board to message their coach." /> : (
        <div className="grid gap-6 lg:grid-cols-[340px_1fr]">
          <ThreadList threads={threads} active={sel && `${sel.recruiter_id}-${sel.player_id}`} onPick={setSel} labelOf={(t) => `${t.player_name ?? "Player"} · ${t.team_name ?? ""}`} />
          {sel ? (
            <div>
              <ThreadView messages={toList(thread.data, ["messages"])} mineSender="recruiter" onSend={send} title={sel.player_name} subtitle={sel.team_name} />
              <Link to={`/recruiter/prospects/${sel.player_id}`} data-testid="thread-open-prospect" className="mt-3 inline-block text-sm text-[#39FF14] underline">Open prospect profile</Link>
            </div>
          ) : <Empty title="Pick a conversation" />}
        </div>
      )}
    </div>
  );
}
